<div class="flex flex-col gap-4">

  <!-- Main tabs: Attive / Recenti — segmented control -->
  <div class="flex items-center bg-emphasis rounded-xl p-1 gap-1">
    <button
      (click)="tabChange.emit('attive')"
      class="flex-1 py-2 text-sm font-medium rounded-lg transition-all cursor-pointer whitespace-nowrap"
      [ngClass]="activeTab === 'attive' ? 'bg-surface-0 dark:bg-surface-900 text-color shadow-sm' : 'text-muted-color hover:text-color'"
    >Attive</button>
    <button
      (click)="tabChange.emit('recenti')"
      class="flex-1 py-2 text-sm font-medium rounded-lg transition-all cursor-pointer whitespace-nowrap"
      [ngClass]="activeTab === 'recenti' ? 'bg-surface-0 dark:bg-surface-900 text-color shadow-sm' : 'text-muted-color hover:text-color'"
    >Recenti</button>
  </div>

  <!-- Sub-filters: Da leggere / Da accettare (toggleable independently) -->
  @if (activeTab === 'attive') {
    <div class="sub-filters">

      <button
        class="filter-pill"
        [class.is-active]="filterDaLeggere"
        (click)="filterToggle.emit('da-leggere')"
      >
        <span class="pill-icon"><i class="fa-light fa-message-dot"></i></span>
        <span class="pill-label">
          Da leggere
          @if (toReadCount > 0) {
            <span class="pill-badge pill-badge--primary">{{ toReadCount }}</span>
          }
        </span>
      </button>

      <button
        class="filter-pill"
        [class.is-active]="filterDaAccettare"
        (click)="filterToggle.emit('da-accettare')"
      >
        <span class="pill-icon"><i class="fa-light fa-message-question"></i></span>
        <span class="pill-label">
          Da accettare
          @if (toAcceptCount > 0) {
            <span class="pill-badge pill-badge--orange">{{ toAcceptCount }}</span>
          }
        </span>
      </button>

    </div>
  }

</div>
